import styled from 'styled-components';
import { GRAYSCALE_800 } from "@styles/colors";
import { INTER } from "@styles/fonts";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
`;

export const ContentContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 16px 12px;
  gap: 24px;
  overflow-y: auto;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ButtonContainer = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 16px 12px 24px 12px;
  width: 100%;
`;

export const InfoContainer = styled.div`
  color: ${GRAYSCALE_800};
  display: flex;
  flex-direction: column;
  font-family: ${INTER.regular};
  font-size: 13px;
`;

export const BoldText = styled.span`
  font-family: ${INTER.bold};
  margin-left: 4px;
`;
